import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VehiclesAdmin from '../components/admin/VehiclesAdmin';
import BookingsAdmin from '../components/admin/BookingsAdmin';
import LocationsAdmin from '../components/admin/LocationsAdmin';
import AdditionalsAdmin from '../components/admin/AdditionalsAdmin';
import GuaranteesAdmin from '../components/admin/GuaranteesAdmin';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('vehicles');

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/login');
  };

  const tabs = [
    { id: 'vehicles', label: 'Vehículos', icon: '🚗' },
    { id: 'bookings', label: 'Reservas', icon: '📋' },
    { id: 'locations', label: 'Ubicaciones', icon: '📍' },
    { id: 'additionals', label: 'Adicionales', icon: '📦' },
    { id: 'guarantees', label: 'Garantías', icon: '🛡️' },
    { id: 'analytics', label: 'Analytics', icon: '📊' }
  ];

  const handleAnalyticsClick = () => {
    navigate('/admin/analytics');
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Panel de Administración</h1>
        <div className="header-actions">
          <button className="logout-btn" onClick={handleLogout}>
            🚪 Cerrar Sesión
          </button>
          <button className="back-btn" onClick={() => navigate('/')}>
            ← Volver al sitio
          </button>
        </div>
      </div>

      <div className="admin-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => {
              if (tab.id === 'analytics') {
                handleAnalyticsClick();
              } else {
                setActiveTab(tab.id);
              }
            }}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="admin-content">
        {activeTab === 'vehicles' && <VehiclesAdmin />}
        {activeTab === 'bookings' && <BookingsAdmin />}
        {activeTab === 'locations' && <LocationsAdmin />}
        {activeTab === 'additionals' && <AdditionalsAdmin />}
        {activeTab === 'guarantees' && <GuaranteesAdmin />}
      </div>
    </div>
  );
};

export default AdminDashboard;
